// extracted by mini-css-extract-plugin
export default {"root":"EditListingWizardTabs_root__h1L-E"};